<template>
  <v-container class="h-100 pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="420">
        <router-link :to="{ name: 'Login' }"
          ><v-img class="mx-auto mb-4" :src="LOGO_HEADER" contain
        /></router-link>
        <div class="text-h5 text-center mb-8 font-weight-medium">Forgot Password</div>

        <div v-if="!validated">
          <v-sheet v-if="!emailSent">
            <v-form
              ref="verificationEmail"
              v-model="isEmailFormValid"
              @submit.prevent="onSubmitSendEmail">
              <v-sheet class="border-opacity-25 border-thin rounded-lg overflow-hidden pa-5">
                <v-text-field
                  v-model="emailForm"
                  label="Email"
                  autocomplete="email"
                  :rules="[rules.required, rules.email]"></v-text-field>
                <div class="invalid-feedback">{{ errors.email_address }}</div>
              </v-sheet>
              <br />
              <v-btn
                color="primary"
                block
                class="rounded-lg mb-8"
                elevation="2"
                :disabled="!isEmailFormValid"
                type="submit">
                Send Email
              </v-btn>
            </v-form>
          </v-sheet>
          <v-sheet v-else>
            <h3 class="text-h6 mb-1">Verification</h3>

            <div class="text-body-2 font-weight-light">
              Enter the code we just sent to the email you provided.
              <span class="font-weight-black text-primary">{{ emailForm }}</span>
            </div>

            <v-otp-input
              v-model="otp"
              class="mt-3 ms-n2"
              length="5"
              placeholder="0"
              :loading="otpLoading"
              :error="otpError"></v-otp-input>

            <v-divider class="mt-3 mb-6"></v-divider>

            <div class="mb-3 text-body-2">Need another <strong>code</strong>?</div>

            <v-btn
              color="primary"
              size="small"
              text="Re-send Email"
              variant="tonal"
              @click="onSubmitSendEmail"></v-btn>
          </v-sheet>
        </div>
        <div v-else>
          <v-row justify="center" class="h-100">
            <v-sheet class="bg-background flex-1-1 px-4" max-width="420">
              <UserPasswordResetComponent
                :allow-close="false"
                :is-admin="false"
                :email="emailForm"
                :otp="otp"
                @password-reset-completed="handlePasswordReset"></UserPasswordResetComponent>
            </v-sheet>
          </v-row>
        </div>
      </v-sheet>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { getForgotPasswordValidationCode, validateForgotPasswordCode } from '@/controllers';
import { LOGO_HEADER, rules } from '@/helpers';
import { ref, watch } from 'vue';
import UserPasswordResetComponent from '@/components/user/UserPasswordResetComponent.vue';
import { router } from '@/router/router';

const otp = ref<string>('');
const otpLoading = ref<boolean>(false);
const otpError = ref<boolean>(false);
const emailSent = ref<boolean>(false);
const emailForm = ref<string>('');
const isEmailFormValid = ref<boolean>(false);
const errors = ref({ apiError: '', email_address: '' });
const validated = ref<boolean>(false);

watch(
  () => otp.value,
  async (value) => {
    if (value.length >= 5) {
      otpError.value = false;
      otpLoading.value = true;
      try {
        const result = await validateForgotPasswordCode(value, emailForm.value);
        if (result) {
          validated.value = result;
          otpError.value = false;
        }
      } catch {
        otpError.value = true;
      }
    }
    otpLoading.value = false;
  },
);

const onSubmitSendEmail = async () => {
  try {
    if (await getForgotPasswordValidationCode(emailForm.value)) {
      emailSent.value = true;
    }
  } catch {
    emailSent.value = true;
  }
};

const handlePasswordReset = async (value: boolean) => {
  if (value) {
    router.push({ name: 'Login' });
  } else {
    throw 'Something went wrong with resetting your password';
  }
};
</script>
